import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "class-rep-dashboard" */ './ClassRepCoursesCtnr'));
